import React from "react";
import { Link } from "react-router-dom";
import bedrijven from "../../Components/Lib/Bedrijven/bedrijven";

const AccommodatiesMenu = ({ token, username, isActive, onToggle }) => {

  // Alleen tonen als gebruiker accommodaties module heeft
  if (username?.bedrijf?.modules?.includes("accommodaties")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fas fa-home"></i>
            </span>
            <span className="menu-text">Accommodaties</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/standplaatsen/accommodaties" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-house"></i>
                </span>
                <span className="menu-text">Accommodaties Overzicht</span>
              </Link>
            </div>
            
            {token.role === "admin" && (
              <>
                <div className="menu-divider"></div>
                <div className="menu-item">
                  <Link to="/standplaatsen/accommodaties/insert" className="menu-link">
                    <span className="menu-icon">
                      <i className="fas fa-plus"></i>
                    </span>
                    <span className="menu-text">Accommodatie Toevoegen</span>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      );
    }
  }
  
  return null;
};

export default AccommodatiesMenu;